import { Component, OnInit } from '@angular/core';
import { FuelTypesService } from 'src/app/services/fuel-types/fuel-types.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fuel-types',
  templateUrl: './fuel-types.component.html',
  styleUrls: ['./fuel-types.component.css']
})
export class FuelTypesComponent implements OnInit{
   page: number = 1;
    count: number = 0;
    searchText: string = '';
    fuel_types: any[] = [];
    public errorMessage: string | null = null;
    public successMessage: string | null = null;
    public isLoading: boolean = false;

    constructor(
      private fuelTypesService: FuelTypesService
    ){}

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchFuelTypes();
  }

  fetchFuelTypes():void{
    this.fuelTypesService.getAll().subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.fuel_types = response.data
          this.isLoading=false;
        }else{
          this.errorMessage=response.message;
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.fetchFuelTypes();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  delete(event: Event,Id:string){
    event.preventDefault();
    this.confirmDelete(Id);
  }

  confirmDelete(Id: string){
      Swal.fire({
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this record? The action is irreversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.isLoading=true;

          this.fuelTypesService.delete(Id)
          .subscribe({
            next: (response) => {
              if(response.status==='success'){
                this.isLoading=false;
                this.successMessage=response.message;
                this.errorMessage=''; //Clear error message incase it's available

                //Reload fuel types
                this.fetchFuelTypes();
              }else if(response.status==='error'){
                this.isLoading=false;
                this.errorMessage=response.message;
              }else{
                this.isLoading=false;
                this.errorMessage=response.message;
              }
            },
            error: (error) => {
              this.isLoading=false;
              this.errorMessage=error;
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {

        }
      })
    }
}
